module.exports = __webpack_public_path__ + "static/media/17.82b1d2d2.gif";